import JSEncrypt from 'jsencrypt';
import api from './client';

// 모듈 레벨 캐시: 공개키 요청은 1회만 (5분 TTL 이내 재사용)
let cachedPublicKey = null;
let cacheExpiry = 0;
const CACHE_TTL_MS = 4 * 60 * 1000; // 4분 (서버 TTL 5분보다 짧게)

/**
 * 서버에서 RSA 공개키를 가져옵니다. 캐시가 유효하면 재사용합니다.
 */
async function getPublicKey() {
  const now = Date.now();
  if (cachedPublicKey && now < cacheExpiry) {
    return cachedPublicKey;
  }
  const res = await api.get('/api/public/login/public-key');
  cachedPublicKey = res.data.publicKey;
  cacheExpiry = now + CACHE_TTL_MS;
  return cachedPublicKey;
}

/**
 * 평문 비밀번호를 RSA 공개키로 암호화하여 Base64 문자열을 반환합니다.
 * 암호화 실패 시 평문을 그대로 반환합니다 (fallback).
 *
 * @param {string} plainPassword - 암호화할 평문 비밀번호
 * @returns {Promise<string>} RSA 암호화된 Base64 문자열
 */
export async function encryptPassword(plainPassword) {
  try {
    const publicKey = await getPublicKey();
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(`-----BEGIN PUBLIC KEY-----\n${publicKey}\n-----END PUBLIC KEY-----`);
    const encrypted = encrypt.encrypt(plainPassword);
    if (!encrypted) throw new Error('RSA 암호화 실패');
    return encrypted;
  } catch {
    // 암호화 실패 시 평문 fallback (개발 환경 호환)
    return plainPassword;
  }
}
